// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__yyyh-","left":"StickyBox_left__155Ai","right":"StickyBox_right__2PARF"};